module.exports = __webpack_public_path__ + "static/img/jolly88-logo.c08afe26.png";